import React, { useEffect, useRef, useState } from "react";
import "./Newaudit.css";
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { UilEditAlt, UilTrash, UilSetting } from "@iconscout/react-unicons";
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from "../../Context/Globalcontext";
import { useTranslation } from "react-i18next";

const Newaudit = (props) => {
  const { t } = useTranslation();

  const inputRefs = useRef([]);
  const [newedit, setNewedit] = useState("new");
  const [input, setInput] = useState({
    kno: "",
    name: "",
    headname: "",
    khtype: "",
    obal: "",
    date: new Date().toISOString().substr(0, 10),
  });
  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [khnames, setKhnames] = useState([]);
  const [value, setValue] = useState("");
  const [stock, setStock] = useState();
  const [sredit, setSredit] = useState("");

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  function handleEnterKey(event, currentIndex) {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }

    if (
      event.key === "Backspace" &&
      ((event.target.tagName === "INPUT" && event.target.value === "") ||
        (event.target.tagName === "SELECT" &&
          event.target.name === "type" &&
          event.target.value === "प्रकार निवडा"))
    ) {
      event.preventDefault();

      let prevIndex = currentIndex - 1;
      while (prevIndex >= 0) {
        const prevElement = inputRefs.current[prevIndex];
        if (prevElement) {
          if (
            (prevElement.tagName === "INPUT" || prevElement.tagName === "SELECT") &&
            prevElement !== event.target
          ) {
            prevElement.focus();
            break;
          } else {
            prevIndex--;
          }
        } else {
          prevIndex--;
        }
      }
    }
  }

  // ✅ type label mapping (keeps backend values SAME as Marathi values)
  const getTypeLabel = (typeValue) => {
    if (!typeValue) return "";
    const map = {
      "रेग्युलर खाते": "Newaudit.typeOptions.regular",
      "व्यापारी खाते": "Newaudit.typeOptions.trader",
      "नफा-तोटा खाते": "Newaudit.typeOptions.profitLoss",
      "ताळेOff खाते": "Newaudit.typeOptions.tallyOff",
    };
    return map[typeValue] ? t(map[typeValue]) : typeValue;
  };

  async function getheading() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios
      .post("https://excellentdairy.com/dairy/php/cust/getheadnames.php", {
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data) setKhnames(response.data);
      })
      .catch((err) => console.log(err));
  }

  const handleChange = async (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;
    setInput((value) => ({ ...value, [name]: valuecurrent }));
  };

  async function getmaxno() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getmaxnoaudit.php", {
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data) {
          setInput((prevInput) => ({
            ...prevInput,
            kno: parseInt(response.data) + 1,
          }));
        } else {
          setInput((prevInput) => ({
            ...prevInput,
            kno: 1,
          }));
        }
        getheading();
      })
      .catch((err) => console.log(err));
  }

  async function getcustdata(kno) {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    setTimeout(() => props.setProgress(70), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getcustomer.php", {
        kno: kno,
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data.length > 0) {
          response.data.map((user) =>
            setInput((prevInput) => ({
              ...prevInput,
              name: user.cname,
            }))
          );
        }
        setTimeout(() => props.setProgress(100), 200);
      })
      .catch((err) => console.log(err));
  }

  function handleEnterKeybutton(event, currentIndex) {
    if (event.key === "Enter") {
      event.preventDefault();
      saveaudit();
      let nextIndex = null;

      if (currentIndex === 0) {
        nextIndex = input.name !== "" ? currentIndex + 1 : currentIndex;
      } else {
        nextIndex = currentIndex + 1;
      }

      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    } else if (event.key === "Backspace") {
      if (event.target.tagName === "BUTTON") {
        if (inputRefs.current[4]) inputRefs.current[4].focus();
      }
    }
  }

  const saveaudit = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);

    // ✅ FIXED: correct required-field validation for THIS form
    const isTypeInvalid = !input.khtype || input.khtype === "प्रकार निवडा";
    if (!input.kno || !input.name || !input.headname || isTypeInvalid || input.obal === "" || !input.date) {
      notifyerror(t("Newaudit.toast.incompleteEntry"));
      return;
    }

    let rawData = {
      kno: input.kno,
      name: input.name,
      headname: input.headname,
      type: input.khtype, // keep backend value as-is (Marathi)
      obal: input.obal,
      date: input.date,
      flag: newedit,
      sredit: sredit,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);
    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/saveaudit2.php", formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        const res = String(response.data || "").trim();

        if (newedit === "new") {
          if (res === "Saved.") {
            notify(t("Newaudit.toast.saved"));

            setInput((prevInput) => ({
              ...prevInput,
              kno: parseInt(input.kno) + 1,
              name: "",
              headname: "",
              obal: "",
              khtype: "",
            }));

            setSredit("");
            setNewedit("new");
            getaudit();

            if (inputRefs.current[0]) inputRefs.current[0].focus();
          }
        } else {
          if (res === "updated.") {
            notify(t("Newaudit.toast.updated"));
            getaudit();
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getmaxno();
    getaudit();
    if (inputRefs.current[0]) inputRefs.current[0].focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getaudit() {
    const mainuser2 = jsEncode.encode("mamapr", 125);

    const base = window.location.hostname === "localhost" ? "https://idairy.co.in" : "";
    axios
      .post(`${base}/api/getaudit`, {
        mainuser: localStorage.getItem("contact"),
        mainuser2,
      })
      .then((response) => {
        if (response.data) {
          setDataSource(response.data);
          localStorage.setItem("auditlist", JSON.stringify(response.data));
          setTimeout(() => props.setProgress(100), 200);
        }
      })
      .catch((err) => console.log(err));
  }

  const handleedit = (kno, name, headname, type, obal, date) => {
    setInput({ kno, name, headname, khtype: type, obal, date });
    setNewedit("edit");
    setSredit(kno);
  };

  async function deleteuchal(sr) {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios
      .post("https://excellentdairy.com/dairy/php/cust/deleteuchal.php", {
        sr: sr,
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data) {
          notify(response.data);
          setInput((prevInput) => ({
            ...prevInput,
            kno: "",
            name: "",
            type: "",
            amt: "",
          }));
          setSredit("");
          setNewedit("new");
          getaudit();
          if (inputRefs.current[1]) inputRefs.current[1].focus();
        }
      })
      .catch((err) => console.log(err));
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  return (
    <div className="khadyamain">
      <div className="firstrowkhadya">
        <img onClick={props.visibility} className="back" src={back} alt="" />
        <div className="colmainkhadya">
          <div className="firstrow2">
            <div className="rowsank">
              <div className="mb-2">
                <span className="subheadsank">{t("Newaudit.form.accountNo")}</span>
                <input
                  disabled
                  onKeyDown={(e) => handleEnterKey(e, 1)}
                  ref={(ref) => (inputRefs.current[1] = ref)}
                  type="number"
                  className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                  autoComplete="off"
                  id="kno"
                  name="kno"
                  value={input.kno}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="linekh" />

      <div className="row1sangh"></div>

      <div className="row1sangh">
        <div className="mb-2">
          <span className="subheadsank">{t("Newaudit.form.subAccountName")}</span>
          <input
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 0)}
            ref={(ref) => (inputRefs.current[0] = ref)}
            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            autoComplete="off"
            id="name"
            name="name"
            value={input.name}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <span className="subheadsank">{t("Newaudit.form.headingName")}</span>
          <input
            list="khnamelist"
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 1)}
            ref={(ref) => (inputRefs.current[1] = ref)}
            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            autoComplete="off"
            id="headname"
            name="headname"
            value={input.headname}
            onChange={handleChange}
          />
          <datalist id="khnamelist">
            {khnames &&
              [...new Set(khnames.map((opt) => opt.headname))].map((uniqueCompany, index) => (
                <option key={index} value={uniqueCompany}>
                  {uniqueCompany}
                </option>
              ))}
          </datalist>
        </div>

        <div className="row1sangh">
          <div className="mb-2">
            <span className="subheadsank">{t("Newaudit.form.accountType")}</span>
            <select
              onKeyDown={(e) => handleEnterKey(e, 2)}
              ref={(ref) => (inputRefs.current[2] = ref)}
              value={input.khtype}
              name="khtype"
              id="khtype"
              onChange={handleChange}
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            >
              {/* keep values as Marathi (backend-safe), show translated labels */}
              <option key={0} value="प्रकार निवडा">
                {t("Newaudit.typeOptions.select")}
              </option>
              <option key={1} value="रेग्युलर खाते">
                {t("Newaudit.typeOptions.regular")}
              </option>
              <option key={2} value="व्यापारी खाते">
                {t("Newaudit.typeOptions.trader")}
              </option>
              <option key={3} value="नफा-तोटा खाते">
                {t("Newaudit.typeOptions.profitLoss")}
              </option>
              <option key={4} value="ताळेOff खाते">
                {t("Newaudit.typeOptions.tallyOff")}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div className="row1sangh">
        <div className="mb-2 cf">
          <span className="subheadsank">{t("Newaudit.form.openingBalance")}</span>
          <input
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 3)}
            ref={(ref) => (inputRefs.current[3] = ref)}
            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            autoComplete="off"
            id="obal"
            name="obal"
            value={input.obal}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <span className="subheadsank">{t("Newaudit.form.date")}</span>
          <input
            onKeyDown={(e) => handleEnterKey(e, 4)}
            ref={(ref) => (inputRefs.current[4] = ref)}
            type="date"
            className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
            autoComplete="off"
            id="date"
            name="date"
            value={input.date}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="linekh" />

      <div className="row1sangh">
        <div className="mb-2">
          <button
            onClick={saveaudit}
            onKeyDown={(e) => handleEnterKeybutton(e, 0)}
            ref={(ref) => (inputRefs.current[4] = ref)}
            type="submit"
            className="btn btn-primary mx-1 sanksmall"
          >
            {newedit === "new" ? t("Newaudit.buttons.save") : t("Newaudit.buttons.update")}
          </button>

          <button type="submit" className="btn btn-primary mx-1 sanksmall">
            {t("Newaudit.buttons.report")}
          </button>
        </div>
      </div>

      <div className="firstrow2">
        <div className="table-containerauditnew">
          <table id="myTable" className="table table-bordered">
            <thead>
              <tr>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.accountNo")}
                </th>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.subAccountName")}
                </th>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.headingName")}
                </th>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.type")}
                </th>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.date")}
                </th>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.openingBalance")}
                </th>
                <th className="thsmall" scope="col">
                  {t("Newaudit.table.action")}
                </th>
              </tr>
            </thead>

            <tbody>
              {value.length > 0
                ? tableFilter.map((user, index) => (
                    <tr key={index}>
                      <td className="thsmall">{user.kno}</td>
                      <td className="thsmall">{user.name}</td>
                      <td className="thsmall">{user.headname}</td>
                      <td className="thsmall">{getTypeLabel(user.type)}</td>
                      <td className="thsmall">{user.date}</td>
                      <td className="thsmall">{user.obal}</td>
                    </tr>
                  ))
                : DataSource.map((user, index) => (
                    <tr key={index}>
                      <td className="thsmallaudit">{user.kno}</td>
                      <td className="thsmallaudit">{user.name}</td>
                      <td className="thsmallaudit">{user.headname}</td>
                      <td className="thsmallaudit">{getTypeLabel(user.type)}</td>
                      <td className="thsmallaudit">{user.date}</td>
                      <td className="thsmallaudit">{user.obal}</td>
                      <td>
                        <UilEditAlt
                          onClick={() => handleedit(user.kno, user.name, user.headname, user.type, user.obal, user.date)}
                          className="icsank"
                        />
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Newaudit;
